
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open-xd-file-old-corrupted",
      function () {
        return require("private-next-pages/open-xd-file-old-corrupted.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open-xd-file-old-corrupted"])
      });
    }
  